import type { LiveUpdatesState } from 'api/liveUpdates.types'
import { Fields as Merchant } from 'models/Merchant'
import { AxiosAction } from 'redux-axios-middleware'
import { ResolvedAxiosAction } from 'utilities/types'

export const GET_MERCHANTS = 'merchant/GET_MERCHANTS'
export const GET_MERCHANTS_SUCCESS = 'merchant/GET_MERCHANTS_SUCCESS'
export const GET_MERCHANTS_FAIL = 'merchant/GET_MERCHANTS_FAIL'

export const GET_MERCHANT = 'merchant/GET_MERCHANT'
export const GET_MERCHANT_SUCCESS = 'merchant/GET_MERCHANT_SUCCESS'
export const GET_MERCHANT_FAIL = 'merchant/GET_MERCHANT_FAIL'

export const SET_MERCHANT_LIVE_UPDATES_STATE =
  'merchant/SET_MERCHANT_LIVE_UPDATES_STATE'

export const setMerchantLiveUpdatesState = (
  merchantId: number,
  liveUpdatesState: LiveUpdatesState
) => ({
  type: SET_MERCHANT_LIVE_UPDATES_STATE,
  payload: { merchantId, liveUpdatesState },
})

export const REQUEST_CUSTOM_CAMPAIGN = 'merchant/REQUEST_CUSTOM_CAMPAIGN'
export const REQUEST_CUSTOM_CAMPAIGN_SUCCESS =
  'merchant/REQUEST_CUSTOM_CAMPAIGN_SUCCESS'
export const REQUEST_CUSTOM_CAMPAIGN_FAIL =
  'merchant/REQUEST_CUSTOM_CAMPAIGN_FAIL'

export function getMerchants(): AxiosAction<
  typeof GET_MERCHANTS,
  { merchants: Merchant[] }
> {
  return {
    type: GET_MERCHANTS,
    payload: {
      client: 'auth',
      request: {
        url: 'merchants/',
        method: 'get',
        // visibility=picker requests the slim payload (id, name, handle,
        // logo_image_urls.default) — drops response from ~121KB to ~47KB
        // and server time from ~3.3s to ~1.3s (sandbox smoke).
        // Companion BE change: thanx/nexus#290 (merged 2026-05-21).
        // Safe alongside getMerchant(id): redux-orm upsert field-merges
        // (model.update spreads `{...existingFields, ...newFields}`),
        // so the slim list response does not overwrite fuller fields
        // loaded by the show endpoint. See merchant.test.ts regression.
        params: {
          visibility: 'picker',
        },
      },
    },
  }
}

export function getMerchant(
  id: number
): AxiosAction<typeof GET_MERCHANT, { merchant: Merchant }> {
  return {
    type: GET_MERCHANT,
    payload: {
      client: 'auth',
      request: {
        url: `merchants/${id}`,
        method: 'get',
      },
    },
  }
}

export function requestCustomCampaign(data: {
  message: string
  name: string
}): AxiosAction<typeof REQUEST_CUSTOM_CAMPAIGN> {
  return {
    type: REQUEST_CUSTOM_CAMPAIGN,
    payload: {
      client: 'default',
      request: {
        url: `actions/request_custom_campaign`,
        method: 'post',
        data: data,
      },
    },
  }
}

export type ResolvedAction =
  | ResolvedAxiosAction<ReturnType<typeof getMerchants>>
  | ResolvedAxiosAction<ReturnType<typeof getMerchant>>
  | ResolvedAxiosAction<ReturnType<typeof requestCustomCampaign>>
  | ReturnType<typeof setMerchantLiveUpdatesState>
